import '../assets/js/map/js/china';
import eCharts from 'echarts';

export default {
    chartPv(ref,data) {
        let option = {
            title: {
                text: '访问数据',
                    subtext: '数据来源：天天短网址',
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data:['PV','UV','IP']
            },
            grid: {
                left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
            },
            toolbox: {
                show : true,
                    feature : {
                    saveAsImage : {show: true}
                }
            },
            xAxis: {
                type: 'category',
                    boundaryGap: false,
                    data: data.date,
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    name:'PV',
                    type:'bar',
                    data:data.pv,
                },
                {
                    name:'UV',
                    type:'line',
                    data:data.uv,
                },
                {
                    name:'IP',
                    type:'line',
                    data:data.ip,
                }
            ]
        };

        eCharts.init(ref).setOption(option);
    },
    chartDev(ref,data) {
        let option = {
            title : {
                text: '客户端统计',
                    subtext: '数据来源：天天短网址',
                    x:''
            },
            tooltip : {
                trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            toolbox: {
                show : true,
                    feature : {
                    saveAsImage : {show: true}
                }
            },
            legend: {
                orient: 'vertical',
                    bottom: 'bottom',
                    data: data.legend,
            },
            calculable : true,
                series : [
                {
                    name:'客户端',
                    type:'pie',
                    radius : '55%',
                    center: ['50%', '55%'],
                    data: data.data,
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        eCharts.init(ref).setOption(option);
    },
    chartBro(ref,data) {
        let option = {
            title: {
                text: '访问者浏览器统计',
                    subtext: '数据来源：天天短网址',
            },
            color: ['#3398DB'],
                tooltip : {
                trigger: 'axis',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            grid: {
                left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
            },
            xAxis : [
                {
                    type : 'category',
                    data : data.name,
                    axisLabel:{
                        interval:0,
                    },
                }
            ],
                yAxis : [{type : 'value'}],
                toolbox: {
                show : true,
                    feature : {
                    saveAsImage : {show: true}
                }
            },
            series : [
                {
                    name:'访问量',
                    type:'bar',
                    barWidth: '30%',
                    data:data.value,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = ['#1997D6', '#06D6A0', '#FED066', '#EF476F', '#0098CB', '#99CC66','#FFCC00','#FF6699'];
                                return colorList[params.dataIndex];
                            }
                        }
                    }
                }
            ]
        };

        eCharts.init(ref).setOption(option);
    },
    chartMap(ref,data) {
        let option = {
            title: {
                text: '全国地图大数据',
                subtext: '数据来源：天天短网址 (最近5000条)',
            },
            tooltip: {
                show: true,
                formatter: function(params) {
                    return params.name + '：' + params.data['value'];
                },
            },
            toolbox: {
                show : true,
                feature : {
                    saveAsImage : {show: true}
                }
            },
            visualMap: {
                text:['高','低'],
                realtime: false,
                calculable: true,
                max: data.maximum,
                inRange: {
                    color: ['lightskyblue','yellow', 'orangered']
                }
            },
            grid: {
                right: 10,
                width: '20%'
            },
            xAxis: {
                show: false
            },
            yAxis: {
                type: 'category',
                inverse: true,
                nameGap: 16,
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: '#ddd'
                    }
                },
                axisTick: {
                    show: false,
                    lineStyle: {
                        color: '#ddd'
                    }
                },
                axisLabel: {
                    interval: 0,
                    margin: 85,
                    textStyle: {
                        color: '#455A74',
                        align: 'left',
                        fontSize: 14
                    },
                    rich: {
                        a: {
                            color: '#fff',
                            backgroundColor: '#FAAA39',
                            width: 20,
                            height: 20,
                            align: 'center',
                            borderRadius: 2
                        },
                        b: {
                            color: '#fff',
                            backgroundColor: '#4197FD',
                            width: 20,
                            height: 20,
                            align: 'center',
                            borderRadius: 2
                        }
                    },
                    formatter: function(params) {
                        let data = [];
                        if (parseInt(params.slice(0, 1)) < 3) {
                            data = [
                                '{a|' + (parseInt(params.slice(0, 1)) + 1) + '}' + '  ' + params.slice(1)
                            ].join('\n')
                        } else {
                            data = [
                                '{b|' + (parseInt(params.slice(0, 1)) + 1) + '}' + '  ' + params.slice(1)
                            ].join('\n')
                        }
                        return data;
                    }
                },
                data: data.name,
            },
            geo: {
                // roam: true,
                map: 'china',
                left: 'left',
                right: '300',
                // layoutSize: '80%',
                label: {
                    emphasis: {
                        show: false
                    }
                },
                itemStyle: {
                    emphasis: {
                        areaColor: '#fff464'
                    }
                }
            },
            series: [{
                name: 'mapSer',
                type: 'map',
                roam: false,
                geoIndex: 0,
                label: {
                    show: false,
                },
                data: data.data,
            }, {
                name: 'barSer',
                type: 'bar',
                roam: false,
                visualMap: false,
                zlevel: 2,
                barMaxWidth: 8,
                barGap: 0,
                itemStyle: {
                    normal: {
                        color: function(params) {
                            // build a color map as your need.
                            var colorList = [{
                                colorStops: [{
                                    offset: 0,
                                    color: '#FFD119' // 0% 处的颜色
                                }, {
                                    offset: 1000,
                                    color: '#FFAC4C' // 100% 处的颜色
                                }]
                            },
                                {
                                    colorStops: [{
                                        offset: 0,
                                        color: '#00C0FA' // 0% 处的颜色
                                    }, {
                                        offset: 1000,
                                        color: '#2F95FA' // 100% 处的颜色
                                    }]
                                }
                            ];
                            if (params.dataIndex < 3) {
                                return colorList[0]
                            } else {
                                return colorList[1]
                            }
                        },
                        barBorderRadius: 15
                    }
                },
                data: data.value,
            }]
        };

        eCharts.init(ref).setOption(option);
    },
    chartTor(ref,data) {
        let option = {
            title: {
                text: '网络供应商统计',
                subtext: '数据来源：天天短网址',
            },
            tooltip : {
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis:  {
                type: 'value'
            },
            yAxis: {
                inverse: true,
                type: 'category',
                data: data.name,
            },
            toolbox: {
                show : true,
                feature : {
                    saveAsImage : {show: true}
                }
            },
            series: [
                {
                    name: '直接访问',
                    type: 'bar',
                    stack: '总量',
                    label: {
                        normal: {
                            show: true,
                            position: 'insideRight'
                        }
                    },
                    barWidth: '30%',
                    data:data.value,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = ['#1997D6', '#06D6A0', '#FED066', '#EF476F', '#0098CB', '#99CC66','#FFCC00','#FF6699'];
                                return colorList[params.dataIndex];
                            }
                        }
                    }
                }
            ]
        };

        eCharts.init(ref).setOption(option);
    },
}
